import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'campaign-step-promo' }

import { type PropType } from 'vue'
import ToggleField from '@/components/PaymentPages/ToggleField.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  enabled: { type: Boolean, default: false },
  promoTemplateId: { type: Number as PropType<number | null>, default: null },
  daysBefore: { type: Number, default: 2 },
  daysAfter: { type: Number, default: 2 },
  // promo code groups with default settings (has_template = 1)
  groups: { type: Array as PropType<any[]>, default: () => [] },
  // prefix the issued codes carry, derived by the parent from the chosen group's name
  promoPrefix: { type: String, default: 'PROMO' },
  templateHasCode: { type: Boolean, default: false }
},
  emits: ['update:enabled', 'update:promo-template-id', 'update:days-before', 'update:days-after'],
  setup(__props) {





// Written as constants: Vue 2 does not allow {{ }} inside attribute values or
// text without treating them as interpolation
const promoToken = '{{promo.code}}'
const hintText = `Each email gets its own single use code built from a promo code group's default settings, valid only around that customer's birthday. Add ${promoToken} to the template to show it.`

return { __sfc: true,promoToken, hintText, ToggleField }
}

})